var React = require('react');

function CheckInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M4 8L7.29464 11L13 5","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round"}));
}

CheckInline.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = CheckInline;

CheckInline.default = CheckInline;
